import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableBody, TableRow, TableCell, IconButton } from "@material-ui/core";
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import NoData from '../../Common/NoDataRow';
import { displayDateTimeFormat } from './../../../utils/staticData';
import moment from 'moment-timezone';

const useStyles = theme => ({
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    },
    lastCell: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: theme.spacing(1)
    },
    tooltipOffset: {
        marginTop: -theme.spacing(2)
    },
    tooltip: {
        fontSize: "0.8rem"
    }
});

const TableContent = props => {
    const { classes, reports, onDelete } = props;

    const handleDelete = (id) => onDelete && onDelete(id);

    const printTable = data => {
        if(!Array.isArray(data) || data.length === 0)
            return <NoData colSpan={8} />;
        let i = 0;
        return data.map(row => {
            return (
                <TableRow
                    key={i++}
                    className={classes.row}
                >
                    <TableCell className={classes.cell}>
                        {i}.
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {moment.unix(row.data).format(displayDateTimeFormat)}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.typ}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.nr_w_kolejce}
                    </TableCell>
                    <TableCell className={classes.cell}>
                        {row.stan}%
                    </TableCell>
                    <TableCell className={classes.lastCell}>
                        <IconButton onClick={handleDelete.bind(this, row.raport_id)}>
                            <DeleteSweepIcon />
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableBody>
            {printTable(reports)}
        </TableBody>
    );
};

TableContent.propTypes = {
    classes: PropTypes.object,
    reports: PropTypes.array,
    onDelete: PropTypes.func,
};

export default withStyles(useStyles)(TableContent);
